import { Component, OnInit, OnDestroy } from '@angular/core';
import { CSPTenantUser } from '../../../models/csp.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageService } from '../../../services/manage.service';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ApiResponse } from '../../../models/api-response.model';
import { CommonService } from '../../../services/common.service';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'dd-csp-end-user-portal-management',
  templateUrl: './csp-end-user-portal-management.component.html',
  styleUrls: ['./csp-end-user-portal-management.component.css']
})
export class CSPEndUserPortalManagementComponent implements OnInit, OnDestroy {

  public endUserSearchStr: string;
  public tenantUsers: CSPTenantUser[];
  private tenantId: string;
  public isStaffAccount: boolean = false; 
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private manageService: ManageService,
    private commonService: CommonService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    
  }

  ngOnInit() {
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.isStaffAccount = res.isStaffAccount;   
    });

    this.activatedRoute.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(param => {
      this.tenantId = param.get('tenantId');

      this.manageService.getTenantUsers(param.get('tenantId'))
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res) => {
          this.tenantUsers = res.filter(m => m.isSelected == true);
          this.manageService.monitorCurrentTenantEndUsers(this.tenantUsers);
        });

      this.manageService.currentEndUserUpdateStatus.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        if (res === 'Success') {
          this.manageService
            .getTenantUsers(this.tenantId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((res) => {
              this.tenantUsers = res.filter(m => m.isSelected == true);
              this.manageService.monitorCurrentTenantEndUsers(this.tenantUsers);
          })
        }
      });
    });
  }

  filterEndUser(user: CSPTenantUser): boolean {
    let result = true;
    if (this.endUserSearchStr) {
      if (!(user.userPrincipalName.toLocaleLowerCase().includes(this.endUserSearchStr.toLocaleLowerCase()) || user.displayName.toLocaleLowerCase().includes(this.endUserSearchStr.toLocaleLowerCase()))) {
        result = false;
      }
    }
    return result;
  }
  
  removeEndUser(user: CSPTenantUser) {
    this.manageService.removeTenantUser(user.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: ApiResponse) => {
      if (res.status) {
        this.manageService.getTenantUsers(this.tenantId).subscribe((res) => {
          this.tenantUsers = res.filter(m => m.isSelected == true);
          this.manageService.monitorCurrentTenantEndUsers(this.tenantUsers);
        },
          (err) => {
            console.log(err);
          })
      } else {
        this.commonService.implementToast('Failed to update end users, please try again', 'Error');
      }
    });
  }

  configureEnduser(): void {
    this.manageService.monitorConfigureEndUserStatus({ status: true, tenantId: this.tenantId, tab: "Enduser" });
  }
  
  configurePortal(): void {
    this.manageService.monitorConfigureEndUserStatus({ status: true, tenantId: this.tenantId, tab: "Portal" });
  }

  configurePortalV1(): void {
    this.router.navigate(['ConfigurePortalManagement'], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
